export const PROMPT_P07 = (sponsorProduct = 'Sika MonoTop-910 S + MonoTop-412 NFG + Sikagard-680 S') => `
Analyze for EXPOSED REBAR CORROSION (ACI 222R).
Visual: rust staining (brown/orange longitudinal streaks), cracks parallel to rebar,
spalling exposing steel, cover depth estimate. Corrosion level: rust_staining_only, surface_rust, pitting, section_loss_minor, section_loss_severe.
Return ONLY this JSON:
{
  "pathology_id": "p07_corrosion",
  "pathology_name": { "es": "Corrosión de armadura expuesta", "en": "Exposed rebar corrosion" },
  "norm": "ACI 222R",
  "confidence": 88,
  "requires_additional_input": false,
  "rebar_exposed": false,
  "corrosion_level": "rust_staining_only|surface_rust|pitting|section_loss_minor|section_loss_severe",
  "corrosion_cause_probable": "carbonation|chloride_attack|poor_cover|mixed",
  "cover_depth_estimate_mm": null,
  "root_cause": { "es": "...", "en": "..." },
  "severity": "low|medium|high|critical",
  "urgency": "deferred|planned|immediate|emergency",
  "repair": {
    "procedure": {
      "es": ["1. Mapear extensión con covermeter electromagnético","2. Demolición 20–25mm detrás del acero corroído","3. Limpieza acero a SA 2.5 (chorro abrasivo). Si pérdida sección >20%: evaluar refuerzo","4. Pasivador bicomponente + puente de adherencia","5. Mortero R3/R4 (EN 1504-3) en capas ≤25mm + revestimiento anticarbonación final"],
      "en": ["1. Map corrosion extent with electromagnetic covermeter","2. Break out 20–25mm behind corroded steel","3. Clean to SA 2.5 (abrasive blast). If section loss >20%: evaluate reinforcement","4. Two-component passivator + bonding agent","5. R3/R4 mortar (EN 1504-3) in ≤25mm layers + anti-carbonation coating"]
    },
    "norm_reference": "ACI 222R-19; EN 1504-7; EN 1504-3 Class R4"
  },
  "materials": {
    "generic": { "es": "Pasivador monocomponente; mortero fibrorreforzado; revestimiento anticarbonación", "en": "Single-component passivator; fiber-reinforced mortar; anti-carbonation coating" },
    "premium": { "product": "${sponsorProduct}", "brand": "Sika", "note": { "es": "Sistema EN 1504 completo: principios 7, 3 y 1", "en": "Complete EN 1504 system: principles 7, 3 and 1" } }
  },
  "linkedin_draft": { "es": "..." },
  "disclaimer": { "es": "Pérdida de sección del acero requiere verificación presencial. Corrosión severa puede comprometer capacidad estructural.", "en": "Steel section loss requires physical verification. Severe corrosion may compromise structural capacity." }
}`;
